import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/orders`;

export default {
  list: (data, options) => Http.post(`${baseUrl}/search`, data, options),
  get: (id, options = {}) => Http.get(`${baseUrl}/${id}`, options),
  summary: (id, options) => Http.get(`${baseUrl}/${id}/summary`, options),
  history: (data, options) => Http.post(`${baseUrl}/${data._id}/history`, data, options),
  pause: (data, options) => Http.post(`${baseUrl}/${data._id}/pause`, data, options),
  resume: (data, options) => Http.post(`${baseUrl}/${data._id}/resume`, data, options),
  copy: (data, options) => Http.post(`${baseUrl}/${data._id}/copy`, data, options),
  cancel: (data, options) => Http.post(`${baseUrl}/${data._id}/cancel`, data, options),

  // Order Segments
  Segment: {
    list: (data, options) => Http.post(`${baseUrl}/${data._id}/segments/search`, data, options),
    get: (data, options) => Http.get(`${baseUrl}/${data._id}/segments/${data.segmentId}`, options),
    getExpandedLocations: (data, options) => {
      return Http.get(`${baseUrl}/${data._id}/segments/${data.segmentId}/locations/expanded`, options);
    },
    history: (data, options) => Http.post(`${baseUrl}/${data._id}/segments/${data.segmentId}/history`, data, options),
  },
};
